import { format } from 'd3-format';
import { Axis } from '../../../plot/components/Axis';
import { useStrip } from '../../../plot/hooks/useStrip';
import { Scale } from '../../../plot/types/scale';

interface Props {
  scale: Scale;
  label?: string;
}
export const ClusterYAxis: React.FC<Props> = ({ scale, label }) => {
  const { width } = useStrip();
  const [min, max] = scale.domain();
  const interval = (min - max) / 3;

  return (
    <g transform={`translate(${width})`}>
      <Axis
        formatter={format('d')}
        scale={scale}
        interval={interval}
        position='left'
        label={label}
      />
    </g>
  );
};
